import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import { Logo } from '@/components/Logo'
import { useAppPath } from '@/hooks/useAppPath.ts'
import { kioskSlice } from '@/store/kioskSlice'
import { licenseSlice } from '@/store/licenseSlice'
import { resetSessionStorageData } from '@/store/sessionStorageMiddleware'
import { INSERT_PERIOD_PATH } from '../../app/router/paths'
import { LanguageSwitcher } from '../../components/LanguageSwitcher'
import { useAppDispatch, useAppSelector } from '../../hooks/store'

export const LandingKioskRoute = () => {
  const license = useAppSelector(licenseSlice.selectors.license)
  const { i18n, t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const insertPeriodPath = useAppPath(INSERT_PERIOD_PATH)
  const dispatch = useAppDispatch()

  useEffect(() => {
    setSearchParams({
      ...searchParams,
      ch: 'kiosk',
    })
  }, [searchParams, i18n.language])

  useEffect(() => {
    dispatch(kioskSlice.actions.resetKiosk())
    resetSessionStorageData(dispatch)
  }, [dispatch])

  if (!license) return null

  return (
    <div className="container flex flex-1 flex-col items-center justify-between gap-8 py-3">
      <div className="flex items-center gap-1">
        <p className="text-xs font-bold">powered by</p>
        <Logo />
      </div>

      <Link
        className="flex flex-col items-center gap-8"
        to={`${insertPeriodPath}?${searchParams.toString()}`}
      >
        <img
          className="h-10"
          src={`https://img.spiagge.it/logo/${license.license}.png`}
        />

        <h2 className="text-center text-3xl font-bold leading-[100%]">
          <Trans i18nKey="kiosk.landing.title" />
        </h2>

        <div className="flex flex-col items-center justify-center">
          <img alt="Kiosk" className="size-14" src="/images/kiosk/start.png" />

          <p className="text-center text-xl font-bold">
            {t('kiosk.landing.start')}
          </p>
        </div>
      </Link>

      <LanguageSwitcher />
    </div>
  )
}
